/**
 * Maintained by Sandon.
 */
const urlPre = window.fe.project || 'purchaser'
export default {
  // 下载模板
  downloadTemplate: {
    url: `/${urlPre}/upload/getTemplate`,
    type: 'get',
    parameter: {
    }
  },
  // 上传
  upload: {
    url: `/${urlPre}/upload/importFile`,
    type: 'post',
    parameter: {
    }
  },
  // 获取预览列表数据
  list: {
    url: `/${urlPre}/upload/queryImportList`,
    type: 'post',
    parameter: {
    }
  },
  // 确认导入
  confirm: {
    url: `/${urlPre}/upload/importConfirm`,
    type: 'post',
    parameter: {
    }
  },
  // 下载错误数据
  error: {
    url: `/${urlPre}/upload/downloadErrorData`,
    type: 'get',
    parameter: {
    }
  },
  // 下载全量数据
  downloadAllData: {
    type: 'get',
    url: `/${urlPre}/upload/downloadAllData`
  },
  // 协议导出错误数据
  protocolError: {
    url: `/${urlPre}/upload/downloadItemData`,
    type: 'get',
    parameter: {
    }
  },
  // 获取导入的数据（弹层形式）
  getSuccessData: {
    type: 'post',
    url: `/${urlPre}/upload/getSuccessData`
  }
}
